import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { getAuthValue } from "../../authModule/hooks/useAuthValue";

type SEND_SMS_PAYLOAD = {
  receiverNumbers: string[];
  message: string;
};

async function sendBroadcastSms(payload: SEND_SMS_PAYLOAD) {
  const { tenantId, hospitalId } = getAuthValue();
  const { data } = await fetcher({
    url: "sms/send",
    method: "POST",
    data: payload,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useSendBroadcastSmsMutation() {
  return useMutation({
    mutationFn: sendBroadcastSms,
  });
}
